export class AddonLimitExceedsCourtroomLimitError extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, AddonLimitExceedsCourtroomLimitError.prototype)
  }
}
